import React, { createContext, useState, useEffect, useContext } from 'react';

export const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contextId] = useState(Math.random().toString(36).substring(2, 9));

  console.log(`[AuthContext:${contextId}] Initializing AuthContext`);

  useEffect(() => {
    const initializeAuth = () => {
      console.log(`[AuthContext:${contextId}] Checking localStorage for user data`);
      const storedUser = localStorage.getItem('user');
      const storedToken = localStorage.getItem('token');

      if (storedUser && storedToken) {
        try {
          const parsedUser = JSON.parse(storedUser);
          console.log(`[AuthContext:${contextId}] Found user in localStorage:`, parsedUser);
          setUser(parsedUser);
        } catch (error) {
          console.error(`[AuthContext:${contextId}] Error parsing stored user:`, error);
          localStorage.removeItem('user');
          localStorage.removeItem('token');
        }
      } else {
        console.log(`[AuthContext:${contextId}] No stored user data found`);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
      }
      setLoading(false);
    };

    initializeAuth();
  }, [contextId]);

  const updateUserState = (userData) => {
    console.log(`[AuthContext:${contextId}] Updating user state:`, userData);
    if (userData) {
      setUser(userData);
      localStorage.setItem('user', JSON.stringify(userData));
    } else {
      setUser(null);
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    }
  };

  const contextValue = {
    user,
    setUser: updateUserState,
    loading
  };

  console.log(`[AuthContext:${contextId}] Providing context value:`, contextValue);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
}; 